import React from "react";

function TabList({ tabs, current, setCurrent }) {

    const onTabClick = (index) => {
        if (tabs[index]?.disabled) {
            return;
        }
        setCurrent(index);
    }

    return (
        <div className="addrules-tab-card-v2">
            {tabs.map((tab, index) => {
                const Icon = tab.icon;
                return (
                    <button
                        key={index}
                        className={`addrules-tab-btn-v2 ${current === index ? 'active' : ''} ${tab.disabled ? 'disabled' : ''}`}
                        disabled={tab.disabled}
                        onClick={() => onTabClick(index)}
                    >
                        {Icon && <Icon />}
                        {tab.name}
                    </button>
                );
            })}
        </div>
    )
}

export default TabList;
